import {Button, IconButton, Tooltip} from "@material-ui/core";
import PendingActions from "icons/PendingActions";
import React from "react";

const styles = {
  iconSize: {
    width: "20px",
  },
  buttonSize: {
    width: "30px",
    height: "30px",
  },
};

interface TrackChangesButtonProps {
  trackingChanges: boolean;
  toggleTrackChanges: () => void;
  useIconButton: boolean;
}

const TrackChangesButton: React.FC<TrackChangesButtonProps> = ({
  trackingChanges,
  toggleTrackChanges,
  useIconButton = false,
}) => {
  if (useIconButton) {
    return (
      <Tooltip
        title={
          trackingChanges ? "Disable track changes" : "Enable track changes"
        }
        placement="top"
        arrow
      >
        <IconButton onClick={toggleTrackChanges} style={styles.buttonSize}>
          <PendingActions
            style={{
              ...styles.iconSize,
              color: trackingChanges ? "#039BE5" : "grey",
            }}
          />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button
      variant="contained"
      color={trackingChanges ? "default" : "primary"}
      style={{height: "30px"}}
      onClick={toggleTrackChanges}
    >
      {`${trackingChanges ? "Disable" : "Enable"} Track Changes`}
    </Button>
  );
};

export default TrackChangesButton;
